<script>
import Multiselect from "vue-multiselect";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export default {
  props: {
    templateType: {
      type: String,
    },
  },
  components: {
    Multiselect,
    MaskedInput,
  },
  data() {
    return {
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "action",
          label: " ",
          thStyle: "width: 5%",
        },
        {
          key: "name",
          thStyle: "width: 75%",
        },
        {
          key: "active",
          thStyle: "width: 15%",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "options",
          label: " ",
          thStyle: "width: 5%",
          tdClass: "text-center align-middle",
        },
      ],
      templates: [],
      selectedCampus: this.$store.state.data.selectedCampus.id,
      templateModal: {
        show: false,
        title: "",
      },
      newTemplate: {
        name: "",
        active: true,
        campusId: this.$store.state.data.selectedCampus.id,
        type: this.templateType,
      },
      templateItems: [],
      accounts: [],
      repoAccount: [],
      selectedAccounts: [],
      fees: [],
      selectedFees: [],
      repoFees: [],
    };
  },
  watch: {
    templateType() {
      this.newTemplate.type = this.templateType;
    },
  },
  methods: {
    selectItem(data) {
      if (data.active) {
        this.$emit("selectTemplate", data);
      } else {
        this.showToast(
          "This template is not active. Please select another one.",
          "error"
        );
      }
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    customLabel({ text, amount }) {
      return `${text} - ${this.formatCurrency(amount)}`;
    },
    fetchTemplates() {
      this.$store.commit("cashiertemplates/SET_CASHIER_TEMPLATES_LOADING", true);
      this.$store
        .dispatch("cashiertemplates/getCashierTemplatesByCampus", {
          campusId: this.selectedCampus,
        })
        .then((response) => {
          this.templates = response.data
            .filter((item) => item.type === this.templateType)
            .map((item) => ({
              ...item,
              showDetails: false,
            }));
          this.$store.commit("cashiertemplates/SET_CASHIER_TEMPLATES_LOADING", false);
        });
    },
    fetchAccounts() {
      this.$store
        .dispatch("accounts/getAllAccounts")
        .then((response) => {
          this.accounts = response.data.map((item) => ({
            value: item.id,
            uacs: item.uacs,
            accountName: item.accountName,
          }));
          this.repoAccount = this.accounts;
        })
        .catch(() => {
          this.showToast(
            "Cannot fetch accounts. Please contact your administrator",
            "error"
          );
        });
    },
    fetchFees() {
      this.$store
        .dispatch("fee/getFeesByCampus", this.selectedCampus)
        .then((response) => {
          this.fees = response.data.map((item) => ({
            value: item.id,
            text: item.name,
            amount: item.defaultAmount,
          }));
          this.repoFees = response.data;
        })
        .catch((error) => {
          this.showToast("Cannot fetch fees. Please contact your administrator", "error");
        });
    },
    addSelectedAccounts() {
      const items = this.selectedAccounts.map((item) => {
        return {
          uacs: item.uacs,
          accountName: item.accountName,
          accountId: item.value,
          isDebit: false,
          defaultAmount: "0",
          active: false,
        };
      });
      this.templateItems.push(...items);
      const selected = items.map((item) => item.accountId);
      this.accounts = this.repoAccount.filter((item) => !selected.includes(item.value));
      this.selectedAccounts = [];
    },
    addSelectedFees() {
      const items = this.selectedFees.map((item) => ({
        fee: { name: item.text },
        feeId: item.value,
        defaultAmount: this.formatNumber(item.amount),
        isDebit: false,
        remarks: "",
      }));

      this.templateItems.push(...items);

      const selectedFees = this.templateItems.map((item) => item.feeId);
      this.fees = this.repoFees
        .filter((item) => !selectedFees.includes(item.id))
        .map((item) => ({
          value: item.id,
          text: item.name,
          amount: item.defaultAmount,
        }));
      this.selectedFees = [];
    },
    showDtls(row) {
      row.item.showDetails = !row.item.showDetails;
      row.toggleDetails();
    },
    displayTemplateModal() {
      this.clearAll();
      this.templateModal = {
        title: "Create New Template",
        show: true,
      };
    },
    closeModal() {
      this.templateModal.show = false;
      this.clearAll();
    },
    clearAll() {
      this.newTemplate = {
        name: "",
        active: true,
        campusId: this.$store.state.data.selectedCampus.id,
        type: this.templateType,
      };
      this.templateItems = [];
      this.accounts = this.repoAccount;
    },
    calculateTotal() {
      this.total = 0;
      this.total = this.loopDisbursementAccounts();
    },
    loopDisbursementAccounts() {
      let val = 0;
      for (let x = 0; x < this.templateItems.length; x++) {
        val += Number(this.getExactAmt(this.templateItems[x].defaultAmount));
      }
      return val;
    },
    deleteItem(item) {
      this.$swal({
        title: "Are you sure?",
        text: "You can add this fee again if you want to.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.templateItems.splice(this.templateItems.indexOf(item), 1);

          const selected = this.templateItems.map((item) => item.feeId);
          this.fees = this.repoFees
            .filter((item) => !selected.includes(item.id))
            .map((item) => ({
              value: item.id,
              text: item.name,
              amount: item.defaultAmount,
            }));
          this.calculateTotal();
        }
      });
    },
    editItem(data) {
      this.templateModal = {
        title: "Edit Template",
        show: true,
      };
      const { active, campusId, id, name, type } = data;
      this.newTemplate = {
        active,
        campusId,
        id,
        name,
        type,
      };
      this.templateItems = data.cashierTemplateItems.map((item) => {
        return {
          fee: item.fee,
          feeId: item.feeId,
          defaultAmount: this.formatNumber(item.defaultAmount),
          isDebit: item.isDebit,
          remarks: "",
          active: item.active,
        };
      });
      const selectedFees = this.templateItems.map((item) => item.feeId);
      this.fees = this.repoFees
        .filter((item) => !selectedFees.includes(item.id))
        .map((item) => ({
          value: item.id,
          text: item.name,
          amount: item.defaultAmount,
        }));
    },
    onSave() {
      this.templateModal.show = false;
      if (this.newTemplate.id > 0) {
        this.$store
          .dispatch("cashiertemplates/updateCashierTemplate", this.newTemplate)
          .then(async (response) => {
            if (response.data.error) {
              return this.showToast(response.data.errorMessage, "error");
            }

            const newTemplateItems = this.templateItems.map((item) => ({
              cashierTemplateId: this.newTemplate.id,
              feeId: item.feeId,
              defaultAmount: Number(this.getExactAmt(item.defaultAmount)),
              active: item.active,
              isDebit: item.isDebit,
            }));
            const { data } = await this.$store.dispatch(
              "cashiertemplates/createTemplateItem",
              newTemplateItems
            );
            if (data.error) {
              return this.showToast(data.errorMessage, "error");
            }
            this.templateModal = {
              title: "",
              show: false,
            };
            this.clearAll();
            this.fetchTemplates();
            this.showToast("Template successfully created", "success");
          })
          .catch((error) => {
            console.log(error);
            this.showToast(
              "Cannot create template. Please contact your administrator",
              "error"
            );
          });
      } else {
        this.$store
          .dispatch("cashiertemplates/createCashierTemplate", this.newTemplate)
          .then(async (response) => {
            if (response.data.error) {
              return this.showToast(response.data.errorMessage, "error");
            }
            if (response.data.id) {
              const newTemplateItems = this.templateItems.map((item) => ({
                cashierTemplateId: response.data.id,
                feeId: item.feeId,
                defaultAmount: Number(this.getExactAmt(item.defaultAmount)),
                active: item.active,
              }));
              const { data } = await this.$store.dispatch(
                "cashiertemplates/createTemplateItem",
                newTemplateItems
              );
              if (data.error) {
                return this.showToast(data.errorMessage, "error");
              }
              this.templateModal = {
                title: "",
                show: false,
              };
              this.clearAll();
              this.fetchTemplates();
              this.showToast("Template successfully created", "success");
            }
          })
          .catch((error) => {
            console.log(error);
            this.showToast(
              "Cannot create template. Please contact your administrator",
              "error"
            );
          });
      }
    },
    deleteTemplate(data) {
      this.$swal({
        title: "Are you sure?",
        text: "You can add this template again if you want to.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("cashiertemplates/deleteCashierTemplate", data.id)
            .then((response) => {
              if (response.data.error) {
                return this.showToast(response.data.errorMessage, "error");
              }
              this.fetchTemplates();
              this.showToast("Template successfully deleted", "success");
            })
            .catch((error) => {
              this.showToast(
                "Cannot delete template. Please contact your administrator",
                "error"
              );
            });
        }
      });
    },
  },
  computed: {
    rows() {
      return this.templates.length;
    },
  },

  created() {
    this.fetchTemplates();
    // this.fetchAccounts();
    this.fetchFees();
  },
};
</script>
<template>
  <div>
    <!-- Modals here... -->
    <b-modal
      size="xl"
      v-model="templateModal.show"
      :title="templateModal.title"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-form-group label="Name" label-class="text-info" class="mb-2">
        <b-form-input
          v-model="newTemplate.name"
          placeholder="Enter Template name..."
        ></b-form-input>
      </b-form-group>
      <b-form-group label="Active?" label-class="text-info" class="mb-2">
        <div class="form-check form-checkbox-outline form-check-success mb-3">
          <input
            class="form-check-input"
            type="checkbox"
            id="customCheckcolor1"
            v-model="newTemplate.active"
          />
          <label class="form-check-label" for="customCheckcolor1">
            Tick check if you want to set this template to active
          </label>
        </div>
      </b-form-group>
      <b-form-group label="Template Items" label-class="text-info" class="mb-2">
        <div class="row mt-3">
          <div class="col-lg-10 mb-3">
            <multiselect
              v-model="selectedFees"
              placeholder="Select fees"
              :custom-label="customLabel"
              :options="fees"
              :searchable="true"
              :multiple="true"
              :close-on-select="false"
              :limit="5"
            >
            </multiselect>
          </div>
          <div class="col-lg-2 pt-1">
            <b-button
              variant="info"
              size="sm"
              class="btn-block align-middle"
              v-if="selectedFees.length > 0"
              @click="addSelectedFees"
              >Add</b-button
            >
          </div>
        </div>
      </b-form-group>
      <div class="custom-table-responsive">
        <table class="table table-sm align-middle table-bordered border-primary mb-0">
          <thead>
            <tr>
              <th width="60%">Fees</th>
              <th class="text-center" width="10%">DR/CR</th>
              <th class="text-center" width="10%">Amount</th>
              <th class="text-center" width="5%">Active</th>
              <th class="text-center" width="5%">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, index) in templateItems">
              <tr :key="index">
                <td class="col-md-5">
                  {{ item.fee.name }}
                </td>
                <td class="col-md-2">
                  <div class="form-check form-checkbox-outline form-check-info">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="`type-${index}`"
                      v-model="item.isDebit"
                    />
                    <label class="form-check-label" :for="`type-${index}`">
                      {{ item.isDebit ? "Debit" : "Credit" }}
                    </label>
                  </div>
                </td>
                <td class="col-md-2">
                  <masked-input
                    autocomplete="off"
                    type="text"
                    v-model="item.defaultAmount"
                    placeholder="Enter Amount..."
                    class="form-control form-control-sm"
                    :mask="currencyMask"
                    @blur="calculateTotal"
                  >
                  </masked-input>
                </td>
                <td class="col-md-2">
                  <div class="form-check form-checkbox-outline form-check-success">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :id="`custom-${index}`"
                      v-model="item.active"
                    />
                    <label class="form-check-label" :for="`custom-${index}`">
                      {{ item.active ? "Active" : "Inactive" }}
                    </label>
                  </div>
                </td>
                <td class="text-center col-md-1">
                  <a href="javascript:void(0)" @click="deleteItem(item)"
                    ><i class="bx bx-trash text-danger"></i
                  ></a>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <small class="text-warning"
        >*** Make sure to hit Save/Update button to save changes</small
      >
      <div class="modal-footer pb-0">
        <b-button variant="info" @click="onSave">
          <i class="bx bx-plus-circle align-middle me-2"></i>
          {{ newTemplate.id > 0 ? "Update" : "Save Now" }}
        </b-button>
        <b-button variant="link" @click="closeModal">
          <i class="mdi mdi-cancel align-middle me-2"></i> Cancel
        </b-button>
      </div>
    </b-modal>
    <div class="row mt-1">
      <div class="col-md-12">
        <div class="d-flex justify-content-between">
          <div>
            <div id="tickets-table_filter" class="dataTables_filter">
              <label class="d-inline-flex align-items-between">
                Search:
                <b-form-input
                  autocomplete="off"
                  v-model="filter"
                  type="search"
                  placeholder="Search..."
                  class="form-control form-control-sm ms-2"
                ></b-form-input>
              </label>
            </div>
          </div>
          <div>
            <b-button size="sm" variant="info" @click="displayTemplateModal">
              <i class="bx bx-plus-medical align-middle me-2"></i>
              <span>Create New Template</span>
            </b-button>
          </div>
        </div>
      </div>
    </div>
    <p class="mb-0">
      <small class="text-warning">***Double click row to select template.</small>
    </p>
    <div class="table-responsive mb-0">
      <b-table
        class="table-nowrap table-hover mb-0"
        :items="templates"
        :fields="fields"
        responsive="sm"
        :per-page="perPage"
        :current-page="currentPage"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :filter="filter"
        :filter-included-fields="filterOn"
        @filtered="onFiltered"
        :busy="false"
        bordered
        hover
        select-mode="single"
        selectable
        @row-dblclicked="selectItem"
        show-empty
      >
        <template #empty="scope">
          <div class="text-center">{{ scope.emptyText }}</div>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center align-items-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-20px h-20px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(action)="row">
          <div
            class="d-flex align-items-center justify-content-center"
            @click="showDtls(row)"
          >
            <i
              class="bx bx-chevron-right rotate font-size-16 cursor-pointer"
              :class="{
                'rotate-90': row.item.showDetails,
              }"
            ></i>
          </div>
        </template>
        <template #cell(active)="row">
          <span v-if="row.item.active" class="badge rounded-pill badge-soft-success"
            >ACTIVE</span
          >
          <span v-else class="badge rounded-pill badge-soft-danger">INACTIVE</span>
        </template>
        <template #cell(options)="row">
          <span class="text-danger" role="button" @click="deleteTemplate(row.item)">
            <i class="bx bx-trash align-middle"></i>
          </span>
        </template>
        <template #row-details="row">
          <div class="row mb-3">
            <div class="col-md-12 text-start text-md-end">
              <b-button variant="warning" size="sm" @click="editItem(row.item)">
                <i class="bx bx-edit-alt align-middle me-2 font-size-15"></i>
                <span class="align-middle me-2">Edit this Template</span>
              </b-button>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-sm mb-0">
              <thead class="table-light">
                <tr>
                  <th>Fee</th>

                  <th class="text-end">Default Amount</th>
                  <th class="text-center">Active</th>
                  <th class="text-center">DR/CR</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="account in row.item.cashierTemplateItems" :key="account.id">
                  <td>
                    <span>{{ account.fee.name }}</span>
                  </td>
                  <td class="text-end">
                    {{ formatCurrency(account.defaultAmount) }}
                  </td>
                  <td class="text-center">
                    <span
                      v-if="account.active"
                      class="badge rounded-pill badge-soft-success"
                      >ACTIVE</span
                    >
                    <span v-else class="badge rounded-pill badge-soft-danger"
                      >INACTIVE</span
                    >
                  </td>
                  <td class="text-center">
                    <span
                      v-if="account.isDebit"
                      class="badge rounded-pill badge-soft-success"
                      >DEBIT</span
                    >
                    <span v-else class="badge rounded-pill badge-soft-danger"
                      >CREDIT</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </b-table>
    </div>
    <div class="row">
      <div class="col">
        <div class="dataTables_paginate paging_simple_numbers float-end">
          <ul class="pagination pagination-rounded mb-0">
            <!-- pagination -->
            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
            ></b-pagination>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
